import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL, playModes, timeModes } from "../../constant";
import "../../index.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Graphs from "./Graphs";
import AppContext from "../../AppContext";
import AssetMap from "./AssetMap";
import AlarmHistoryTable from "./AlarmHistoryTable";
import DetailsSensorConfigure from "./DetailsSensorConfigure";
import PlayBackTrack from "./PlayBackTrack";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import Details from "./Details";
import { formatDate } from "@telerik/kendo-intl";
import { confirmAlert } from "react-confirm-alert";
import KendoLoadingPanel from "../KendoLoadingPanel";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { ReactSVG } from "react-svg";
import ParentView from "./assetDetailsViews/ParentView";
import AssetView from "./assetDetailsViews/AssetView";

function AssetDetails({ assetType }) {
  const {
    authCtx,
    config,
    setConfig,
    getTimeZoneDateTime,
    assets,
    playbackMode,
    setPlayBackMode,
    darkMode,
  } = useContext(AppContext);
  const currentTime = getTimeZoneDateTime(new Date());
  const detailsRef = useRef();
  const graphRef = useRef();
  const tableRef = useRef();
  const mapRef = useRef();
  const playTrackRef = useRef();
  const { t } = useTranslation();
  const [assetData, setAssetData] = useState();
  const [selectedAsset, setSelectedAsset] = useState(null);
  const { assetId } = useParams();
  const [autoCenter, setAutoCenter] = useState(true);
  const [expanded, setExpanded] = useState(null);
  // const [detailsPreference, setDetailsPreference] = useState({
  //   userId: authCtx.profile.id,
  // });
  const [mode, setMode] = useState({ map: 6, graph: 6, table: 6 });
  const navigate = useNavigate();
  const [alarmLines, setAlarmLines] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(currentTime.getTime() - 24 * 60 * 60 * 1000),
    endDate: currentTime,
  });
  const [playBackData, setPlayBackData] = useState(null);
  const [pointDatas, setPointDatas] = useState(null);
  const [currentPlayTime, setCurrentPlayTime] = useState(null);
  const [momentData, setMomentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [childAssets, setChildAssets] = useState([]);
  const [loadedAssetIsChild, setLoadedAssetIsChild] = useState(false);

  const onPlayBackClear = () => {
    if (detailsRef.current) detailsRef.current.clearChildState();
    if (mapRef.current) mapRef.current.clearChildState();
    if (graphRef.current) graphRef.current.clearChildState();
    if (tableRef.current) tableRef.current.clearChildState();
    if (playTrackRef.current) playTrackRef.current.clearChildState();
    setCurrentPlayTime(dateRange.startDate);
    setPlayBackData(null);
  };

  const goBackClick = () => {
    setPlayBackMode(100);
    if (!loadedAssetIsChild) navigate("/home");
    else {
      setLoadedAssetIsChild(false);
      setSelectedAsset(null);
    }
  };

  const loadParentAssetData = async () => {
    setLoading(true);
    let res = await axios.get(`${BASE_URL}/api/Asset/${assetId}`);
    if (res.status === 200) {
      const locationProperty = res.data.properties.find((x) => x.isLocation);
      const locations = locationProperty.value.split(",");
      let getChildAssets = assets.filter((a) => a.parentId === assetId);
      setAssetData({
        ...res.data,
        gnss:
          locationProperty && locations.length === 2
            ? {
              latitude: parseFloat(locations[0]),
              longitude: parseFloat(locations[1]),
            }
            : null,
      });
      setChildAssets(getChildAssets);
      setLoading(false);
    }
  };

  const loadData = async () => {
    let obj = assets.find((a) => a.id === assetId);
    setAssetData(obj);
  };

  const onDetailsConfig = (configType) => {
    const configAsset = assetType === "parent" ? selectedAsset : assetData;
    if (configAsset)
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <DetailsSensorConfigure
              setPopup={onClose}
              parametersList={configAsset.parameters}
              // sensorslist={fields.sensors}
              detailsPreference={config}
              setDetailsPreference={setConfig}
              configType={configType}
              devicelist={configAsset?.devices}
              assetId={configAsset.id}
              assets={assets}
              darkMode={darkMode}
            />
          );
        },
      });
  };

  // useEffect(() => {
  //   loadConfiguration();
  // }, []);

  useEffect(() => {
    if (playbackMode === 200)
      setDateRange({
        startDate: new Date(
          currentTime.getTime() - 24 * 60 * 60 * 1000
        ),
        endDate: currentTime,
      });
  }, [playbackMode]);

  useEffect(() => {
    if (assets && assets.length > 0) {
      if (assetType == "asset") {
        loadData();
      } else {
        let getChildAssets = assets.filter((a) => a.parentId === assetId);
        setChildAssets(getChildAssets);
      }
    }
  }, [assets]);

  useEffect(() => {
    if (assetType == "parent") {
      loadParentAssetData();
    }
  }, []);

  const memoize = (func) => {
    const cache = {};
    return (...args) => {
      const key = JSON.stringify(args);
      if (!(key in cache)) {
        cache[key] = func(...args);
      }
      return cache[key];
    };
  };

  // Memoized version of getTimeZoneDateTime function
  const memoizedGetTimeZoneDateTime = memoize(getTimeZoneDateTime);

  const onDateRangeSubmit = async () => {
    onPlayBackClear();
    setLoading(true);
    setCurrentPlayTime(dateRange.startDate);
    let start =
      dateRange.startDate.toISOString().slice(0, 23) + "Z";
    let end =
      dateRange.endDate.toISOString().slice(0, 23) + "Z";
    const payload = (
      assetType === "parent" ? selectedAsset : assetData
    )?.parameters.map((cg) => ({
      deviceId: cg.deviceId,
      parameterId: cg.parameterId,
      assetId: assetType === "parent" ? selectedAsset.id : assetId,
    }));
    let res = await axios.post(
      `${BASE_URL}/api/DeviceData/PlayBackData?startTime=${start}&endTime=${end}`,
      payload.filter((x) => x.deviceId !== null)
    );
    if (res.status === 200) {
      const modifiedAlarms = [];
      res.data.alarms.forEach((d) => {
        modifiedAlarms.push({
          ...d,
          clearedUser: null,
          acknowledgeUser: null,
          timeStamp: memoizedGetTimeZoneDateTime(d.timeStamp),
        });
        if (d.acknowledgeUser !== null)
          modifiedAlarms.push({
            ...d,
            clearedUser: null,
            timeStamp: memoizedGetTimeZoneDateTime(d.acknowledgeTime),
          });
        if (d.clearedUser !== null)
          modifiedAlarms.push({
            ...d,
            timeStamp: memoizedGetTimeZoneDateTime(d.clearedTime),
          });
      });
      const boundData = res.data.datas
        .map((z) =>
          z.gnss.latitude !== 0 && !z.gnss.latitude.startsWith("0")
            ? {
              lat: parseFloat(z.gnss.latitude),
              lng: parseFloat(z.gnss.longitude),
            }
            : null
        )
        .filter((x) => x !== null);
      if (mapRef.current) mapRef.current.setMapBounds(boundData);
      const modifiedRes = {
        datas: res.data.datas.map((x) => getModifiedData(x)),
        alarms: modifiedAlarms,
      };
      ProcessPlayBackData(modifiedRes);
      setPlayBackData(modifiedRes);
    }
    setLoading(false);
  };

  const getModifiedData = (newData) => {
    const isLatValid =
      newData.gnss.latitude !== 0 && !newData.gnss.latitude.startsWith("0");
    const modifiedData = {
      ...newData,
      gnss: isLatValid
        ? {
          Latitude: newData.gnss.latitude,
          Longitude: newData.gnss.longitude,
        }
        : {
          Latitude: 0,
          Longitude: 0,
        },
      timeStamp: getTimeZoneDateTime(newData.timeStamp),
      Values: newData.values.map((v) => ({
        Id: v.id,
        ParameterId: v.parameterId,
        Value: v.value,
        AssetId: v.assetId,
      })),
    };
    return modifiedData;
  };

  const getDevicedTime = () => {
    const timeDifferenceMs =
      dateRange.endDate.getTime() -
      dateRange.startDate.getTime();
    const minutesDifference = Math.floor(timeDifferenceMs / (1000 * 60));
    const divisedTime = 100 / minutesDifference;
    return divisedTime;
  };

  function generateTimesArray(startDate, endDate) {
    const timesArray = [];
    let currentTimeLoop = new Date(startDate.getTime());

    while (currentTimeLoop <= endDate) {
      timesArray.push(new Date(currentTimeLoop.getTime()));
      currentTimeLoop.setTime(currentTimeLoop.getTime() + 60000); // Adding 60,000 milliseconds (1 minute)
    }

    return timesArray;
  }

  const ProcessPlayBackData = (data) => {
    let start = dateRange.startDate;
    const endDate = new Date(dateRange.endDate).setSeconds(
      0,
      0
    );
    const devisedTime = getDevicedTime();
    let sliderValue = 0;
    const finalData = [];
    const times = generateTimesArray(start, endDate);
    times.forEach((time) => {
      const addedTimeInSeconds = time.setSeconds(0, 0); // Convert milliseconds to seconds
      let datas = data.datas.filter(
        (x) => x.timeStamp.setSeconds(0, 0) === addedTimeInSeconds
      );
      sliderValue += devisedTime;
      if (datas.length > 0) {
        let momentData = {
          sliderPoint: sliderValue,
          timeStamp: datas[0].timeStamp,
          dataAndAlarm: [],
        };
        datas.forEach((newData, dataIndex) => {
          const modifiedData = newData;
          const newAlarms = data.alarms
            .filter((x) => x.timeStamp.setSeconds(0, 0) === addedTimeInSeconds)
            .sort((a, b) => a.timeStamp - b.timeStamp);
          const dataAlarm = { data: modifiedData, alarms: newAlarms };
          momentData.dataAndAlarm.push(dataAlarm);
        });
        finalData.push(momentData);
      } else {
        const newAlarms = data.alarms
          .filter((x) => x.timeStamp.setSeconds(0, 0) === addedTimeInSeconds)
          .sort((a, b) => a.timeStamp - b.timeStamp);

        const momentData = {
          sliderPoint: sliderValue,
          timeStamp: new Date(addedTimeInSeconds),
          dataAndAlarm: [{ data: null, alarms: newAlarms }],
        };
        finalData.push(momentData);
      }
    });
    setPointDatas(finalData);
  };

  function isTimeDifferenceMoreThan24Hours() {
    // Convert the dates to timestamps (milliseconds since Jan 1, 1970)
    const timestamp1 = dateRange.startDate?.getTime();
    const timestamp2 = dateRange.endDate?.getTime();

    // Calculate the absolute difference in milliseconds
    const timeDifference = Math.abs(timestamp2 - timestamp1);

    // Check if the time difference is more than 24 hours (in milliseconds)
    const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000;
    return timeDifference > twentyFourHoursInMilliseconds;
  }

  const onChildAssetView = (selectedAsset) => {
    setSelectedAsset(selectedAsset);
    setLoadedAssetIsChild(true);
  };

  return (
    <div className="flex flex-col h-full pb-6 md:px-7 px-3 md:pl-12 relative w-full overflow-y-scroll overflow-x-hidden md:overflow-hidden dark:bg-neutral-900 bg-white">
      <div className=" w-[95vw] pr-2 md:pr-0 h-9 text-xs -top-0 md:pl-6 pl-2 flex items-center justify-between text-white font-semibold">
        <div
          className={`flex items-center h-max md:gap-4 gap-1 ${darkMode ? "darkCombo" : "lightCombo"
            }`}
        >
          {playbackMode === 200 && (
            <>
              <DateTimePicker
                className="md:h-7 h-5 md:text-xs text-xxs placeholder:text-white"
                placeholder={t("assetDetails.playbackRangeStartPlaceholder")}
                width={200}
                format="dd-MM-yyyy hh:mm a"
                value={dateRange.startDate}
                onChange={(e) =>
                  setDateRange((pre) => ({
                    ...pre,
                    startDate: e.target.value,
                  }))
                }
                max={dateRange.endDate}
              />
              <DateTimePicker
                className="md:h-7 h-5 md:text-xs text-xxs placeholder:text-white"
                placeholder={t("assetDetails.playbackRangeEndPlaceholder")}
                width={200}
                format="dd-MM-yyyy hh:mm a"
                value={dateRange.endDate}
                onChange={(e) =>
                  setDateRange((pre) => ({
                    ...pre,
                    endDate: e.target.value,
                  }))
                }
                min={dateRange.startDate || currentTime}
                max={
                  (dateRange?.startDate &&
                    new Date(
                      dateRange?.startDate?.getTime() + 24 * 60 * 60 * 1000
                    )) ||
                  currentTime
                }
              />
              <button
                type="button"
                className="dark:bg-indigo-600 bg-addNewItemBtns md:px-2 px-1 md:h-7 h-5 my-auto rounded disabled:opacity-30"
                disabled={isTimeDifferenceMoreThan24Hours()}
                onClick={() => onDateRangeSubmit()}
              >
                {t("button.apply")}
              </button>
              <button
                type="button"
                className="bg-red-500 md:px-2 px-1 md:h-7 h-5 my-auto rounded"
                onClick={() => onPlayBackClear()}
              >
                {t("button.clear")}
              </button>
              {isTimeDifferenceMoreThan24Hours() && (
                <div className="text-red-600 truncate w-fit">
                  {t("assetDetails.playbackRangeWarning")}
                </div>
              )}
            </>
          )}
        </div>
        {(assetType === "asset" || loadedAssetIsChild) && (
          <div className=" flex bg-zinc-900 border md:text-xxs text-xxxs lg:text-xs md:mr-4 mr-0 border-white rounded-full md:w-28 w-24 lg:w-36 md:h-6 h-5 lg:h-7 mb-1">
            {playModes.map((pm, index) => (
              <button
                type="button"
                className={`w-full rounded-full text-center ${playbackMode === pm.id
                  ? "bg-indigo-600 border-zinc-900 border-2"
                  : ""
                  }`}
                key={index}
                onClick={() => {
                  setPlayBackMode(pm.id);
                  if (pm.id === 100) {
                    setDateRange({ endDate: null, startDate: null });
                  }
                  onPlayBackClear();
                }}
              >
                {t(`button.playModes.${pm.id}`)}
              </button>
            ))}
          </div>
        )}
      </div>
      {(assetType === "asset" && assetData) ||
        (loadedAssetIsChild && selectedAsset) ? (
        <AssetView
          alarmLines={alarmLines}
          assetData={loadedAssetIsChild ? selectedAsset : assetData}
          autoCenter={autoCenter}
          setAutoCenter={setAutoCenter}
          expanded={expanded}
          currentPlayTime={currentPlayTime}
          dateRange={dateRange}
          detailsRef={detailsRef}
          mapRef={mapRef}
          mode={mode}
          goBackClick={goBackClick}
          setMode={setMode}
          t={t}
          graphRef={graphRef}
          tableRef={tableRef}
          loading={loading}
          momentData={momentData}
          onDetailsConfig={onDetailsConfig}
          setAlarmLines={setAlarmLines}
          setExpanded={setExpanded}
          loadedAssetIsChild={loadedAssetIsChild}
          assetType={assetType}
        />
      ) : assetType === "parent" ? (
        <ParentView
          assetData={assetData}
          expanded={expanded}
          goBackClick={goBackClick}
          onDetailsConfig={onDetailsConfig}
          setExpanded={setExpanded}
          t={t}
          ref={detailsRef}
          autoCenter={autoCenter}
          detailsRef={detailsRef}
          mapRef={mapRef}
          momentData={momentData}
          setAutoCenter={setAutoCenter}
          childAssets={childAssets}
          onChildAssetView={onChildAssetView}
        />
      ) : null}
      {loading && <KendoLoadingPanel />}
      {playbackMode === 200 &&
        playBackData &&
        playBackData.datas &&
        playBackData.datas.length > 0 && (
          <PlayBackTrack
            dateRange={dateRange}
            playBackData={playBackData}
            momentData={momentData}
            setMomentData={setMomentData}
            currentPlayTime={currentPlayTime}
            setCurrentPlayTime={setCurrentPlayTime}
            assetData={assetData}
            ref={playTrackRef}
            setLoading={setLoading}
            getTimeZoneDateTime={getTimeZoneDateTime}
            pointDatas={pointDatas}
          />
        )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
}

export default AssetDetails;
